import React, { useState, useEffect } from "react";
import { FormInput, FormSelect, Row, Col, Button } from "shards-react";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import styled from "styled-components";

const Table17 = (props) => {
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const [onEditCurrent, setOnEditCurrent] = useState(
    props.type === "edit" ? false : true
  );
  const [PowerbiData, setPowerbiData] = useState(null);
  const [groupList, setGroup] = useState(null);
  const [occupationlaborskillList, setOccupationlaborskill] = useState([]);
  const [occupationprofessionalList, setOccupationprofessional] = useState([]);
  const [occupationstandardList, setOccupationstandard] = useState([]);
  const [standardList, setStandard] = useState(null);

  const axios = require("axios").default;
  //4 สร้างข้อมูลเพื่อส่งไปอนุมัติ
  const onCeateTable = () => {
    const obj = [];
    PowerbiData.map((item, index) =>
      item.topicValue.map((costItem, key) => {
        const data = {
          yearId: props.yearId,
          periodNo: 1,
          groupId: item.groupId,
          standardId: item.standardId,
          topicId: costItem.topicId,
          fillValue: costItem.fillValue,
        };
        obj.push(data);
      })
    );
    const filter = obj.filter((item) => item.fillValue === "");
    console.log("@PowerbiData", filter);
    if (filter.length > 0) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      return false;
    }
    props.onCeateTable(obj);
  };

  const getCurrentData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId || null,
        tableHeadId: props.listheadId || null,
        yearNo: props.newHeadId ? null : Number(props.yearNo),
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        if (response.data.data.length > 0) {
          if (response.data.data[0].list.length == 0) {
            getNewData();
          } else {
            const viewData = [];
            if (props.tableTabSettingId == 36) {
              response.data.data[0].list.map((item) => {
                const filterHead = viewData.filter(
                  (fil) =>
                    fil.standardId == item.standardId &&
                    fil.groupId == item.groupId
                );
                if (filterHead.length == 0) {
                  const obj = {
                    standardId: item.standardId,
                    groupId: item.groupId,
                    topicValue: [
                      {
                        topicId: item.topicId,
                        fillValue:
                          props.type === "new" && props.newHeadId
                            ? response.data.data[0].yearId != props.yearId
                              ? ""
                              : item.fillValue
                            : item.fillValue,
                      },
                    ],
                  };
                  viewData.push(obj);
                } else {
                  const index = viewData.findIndex(
                    (ind) =>
                      ind.standardId == item.standardId &&
                      ind.groupId == item.groupId
                  );
                  const topicValue = {
                    topicId: item.topicId,
                    fillValue:
                      props.type === "new" && props.newHeadId
                        ? response.data.data[0].yearId != props.yearId
                          ? ""
                          : item.fillValue
                        : item.fillValue,
                  };
                  const newCost = [...viewData[index].topicValue];
                  newCost.push(topicValue);
                  viewData[index].topicValue = newCost.sort(function(a, b) {
                    return a.topicId - b.topicId;
                  });
                }
              });
              setPowerbiData(viewData);
            } else {
              setPowerbiData(response.data.data[0].list);
            }
            setLoading(false);
          }
        } else {
          setLoading(false);
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getNewData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId,
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        setLoading(false);
        if (response.data.data.length > 0) {
          const viewData = [];
          response.data.data[0].list.map((item) => {
            const filterHead = viewData.filter(
              (fil) =>
                fil.standardId == item.standardId && fil.groupId == item.groupId
            );
            if (filterHead.length == 0) {
              const obj = {
                standardId: item.standardId,
                groupId: item.groupId,
                topicValue: [
                  {
                    topicId: item.topicId,
                    fillValue: "",
                  },
                ],
              };
              viewData.push(obj);
            } else {
              const index = viewData.findIndex(
                (ind) =>
                  ind.standardId == item.standardId &&
                  ind.groupId == item.groupId
              );
              const typeValue = {
                topicId: item.topicId,
                fillValue: "",
              };
              const newCost = [...viewData[index].typeValue];
              newCost.push(typeValue);
              viewData[index].typeValue = newCost.sort(function(a, b) {
                return a.typeId - b.typeId;
              });
            }
          });
          setLoading(false);
          setPowerbiData(viewData);
        } else {
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getGroup = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table17/table17group`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        console.log("setType", response.data);
        setGroup(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table17/table17group", error);
      });
  };

  const getOccupationlaborskill = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table17/table17occupationlaborskill`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setOccupationlaborskill(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table17/table17occupationlaborskill", error);
      });
  };

  const getOccupationprofessional = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table17/table17occupationprofessional`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setOccupationprofessional(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table17/table17occupationprofessional", error);
      });
  };

  const getOccupationstandard = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table17/table17occupationstandard`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setOccupationstandard(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table17/table17occupationstandard", error);
      });
  };

  const getStandard = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table17/table17standard`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setStandard(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table17/table17standard", error);
      });
  };

  useEffect(() => {
    getGroup();
    getOccupationlaborskill();
    getOccupationprofessional();
    getOccupationstandard();
    getStandard();

    getCurrentData();
  }, []);

  useEffect(() => {
    getCurrentData();
  }, [props.yearId]);

  const onAddRowTable = () => {
    let datas = [...PowerbiData];
    const data = { ...datas[0] };
    data.topicValue.map((item) => (item.fillValue = ""));
    setPowerbiData(datas.concat([data]));
  };

  const onSetdataCost = (index, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index].fillValue = value;
    setPowerbiData(newTodos);
  };

  const onSetdata = (index, dataName, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index][dataName] = value;
    setPowerbiData(newTodos);
  };

  const getOccupationStandardData = (id) => {
    if (occupationstandardList.length > 0) {
      return occupationstandardList.filter(
        (item) => item.occupationStandardId == id
      );
    }
    return [];
  };

  const getOccupationLaborskillData = (id) => {
    if (occupationlaborskillList.length > 0) {
      return occupationlaborskillList.filter(
        (item) => item.occupationLaborskillId == id
      );
    }
    return [];
  };

  const getOccupationprofessionalData = (id) => {
    if (occupationprofessionalList.length > 0) {
      return occupationprofessionalList.filter(
        (item) => item.occupationProfessionalId == id
      );
    }
    return [];
  };

  return (
    <Row>
      {props.tableTabSettingId == 36 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5 style={{ float: "left" }}>
              จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
              แถว
            </h5>

            {props.type === "edit" ? (
              onEditCurrent && (
                <Button
                  theme="success"
                  onClick={() => onAddRowTable()}
                  style={{ float: "right", width: 200 }}
                >
                  เพิ่มแถว
                </Button>
              )
            ) : (
              <Button
                theme="success"
                onClick={() => onAddRowTable()}
                style={{ float: "right", width: 200 }}
              >
                เพิ่มแถว
              </Button>
            )}
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">มาตรฐาน</th>
                  <th scope="col">การแบ่งกลุ่ม</th>
                  <th scope="col">ทั้งหมด</th>
                  <th scope="col">เกี่ยวข้องกับโลจิสติกส์</th>
                  <th scope="col">ไม่เกี่ยวข้องกับโลจิสติกส์ </th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={6}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.standardId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "standardId", e.target.value);
                          }}
                        >
                          {standardList != null &&
                            standardList.length > 0 &&
                            standardList.map((item) => {
                              return (
                                <option value={item.standardId}>
                                  {item.standardName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.groupId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "groupId", e.target.value);
                          }}
                        >
                          {groupList != null &&
                            groupList.length > 0 &&
                            groupList.map((item) => {
                              return (
                                <option value={item.groupId}>
                                  {item.groupName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      {item.topicValue.map((type, key) => (
                        <td style={{ padding: 5 }}>
                          <FormInput
                            type="number"
                            value={type.fillValue}
                            placeholder={"fillValue"}
                            disabled={!onEditCurrent}
                            onChange={(e) => {
                              onSetdataCost(
                                index,
                                key,
                                "fillValue",
                                Number(e.target.value)
                              );
                            }}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={6}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}
      {console.log("PowerbiData", PowerbiData)}
      {props.tableTabSettingId == 37 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5>
              ข้อมูลชุดนี้เป็น Data Master หากต้องการเพิ่มกรุณาเพิ่มที่หน้า
              Upload file
            </h5>
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Code</th>
                  <th scope="col">Occupation standard</th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={3}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        {getOccupationStandardData(item.occupationStandardId)
                          .length > 0
                          ? getOccupationStandardData(
                              item.occupationStandardId
                            )[0].occupationStandardCode
                          : ""}
                      </td>
                      <td>
                        {getOccupationStandardData(item.occupationStandardId)
                          .length > 0
                          ? getOccupationStandardData(
                              item.occupationStandardId
                            )[0].occupationStandardName
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={3}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 38 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5>
              ข้อมูลชุดนี้เป็น Data Master หากต้องการเพิ่มกรุณาเพิ่มที่หน้า
              Upload file
            </h5>
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">มาตรฐานอาชีพ (หน่วย)</th>
                  <th scope="col">มาตรฐานฝีมือแรงงาน (สาขาอาชีพ)</th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={2}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        {getOccupationStandardData(item.occupationStandardId)
                          .length > 0
                          ? getOccupationStandardData(
                              item.occupationStandardId
                            )[0].occupationStandardName
                          : ""}
                      </td>
                      <td>
                        {getOccupationLaborskillData(
                          item.occupationLaborskillId
                        ).length > 0
                          ? getOccupationLaborskillData(
                              item.occupationLaborskillId
                            )[0].occupationLaborskillName
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={2}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 39 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5>
              ข้อมูลชุดนี้เป็น Data Master หากต้องการเพิ่มกรุณาเพิ่มที่หน้า
              Upload file
            </h5>
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">มาตรฐานอาชีพ (หน่วย)</th>
                  <th scope="col">มาตรฐานวิชาชีพ (สาขาวิชาชีพย่อย)</th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={2}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        {getOccupationStandardData(item.occupationStandardId)
                          .length > 0
                          ? getOccupationStandardData(
                              item.occupationStandardId
                            )[0].occupationStandardName
                          : ""}
                      </td>
                      <td>
                        {getOccupationprofessionalData(
                          item.occupationProfessionalId
                        ).length > 0
                          ? getOccupationprofessionalData(
                              item.occupationProfessionalId
                            )[0].occupationProfessionalName
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={2}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 36 ? (
        props.type === "edit" ? (
          <Col md="12" style={{ padding: "15px" }}>
            {onEditCurrent ? (
              <Button
                theme="success"
                onClick={() => onCeateTable()}
                style={{ float: "right", width: 200 }}
              >
                บันทึกข้อมูล
              </Button>
            ) : props.status == 0 && props.userType != 3 ? (
              <Button
                theme="success"
                onClick={() => props.onApproveTable()}
                style={{ float: "right", width: 200 }}
              >
                อนุมัติเผยแพร่
              </Button>
            ) : null}
            {!onEditCurrent && (
              <Button
                outline
                theme="secondary"
                onClick={() => setOnEditCurrent(true)}
                style={{ float: "right", width: 200, marginRight: 20 }}
              >
                แก้ไขข้อมูล
              </Button>
            )}
          </Col>
        ) : (
          <Col md="12" style={{ padding: "15px" }}>
            <Button
              theme="success"
              onClick={() => onCeateTable()}
              style={{ float: "right", width: 200 }}
            >
              บันทึกข้อมูล
            </Button>
          </Col>
        )
      ) : props.status == 0 && props.userType != 3 ? (
        <Col md="12" style={{ padding: "15px" }}>
          <Button
            theme="success"
            onClick={() => props.onApproveTable()}
            style={{ float: "right", width: 200 }}
          >
            อนุมัติเผยแพร่
          </Button>
        </Col>
      ) : null}
    </Row>
  );
};

export default Table17;
